import Grid from '@mui/material/Unstable_Grid2'
import { IUser, ROLES } from '../../../../models/user'
import { CustomTextField } from '../../../../../../shared/components/inputs'
import { UserBrandAutocomplete } from '../../forms/UserBrandAutocomplete'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../../redux/types'

interface HeaderInputsProps {
  user: IUser
  handleInputChange: (inputName: string, value: any) => void
}

export function HeaderInputs({ user, handleInputChange }: HeaderInputsProps) {
  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { userSelected } = useSelector((state: IRootState) => state.user)

  return (
    <Grid container alignItems="flex-start" justifyContent="space-between" spacing={2}>
      <Grid xs={12} sm={user.role_id === ROLES.client && authUser.role_id !== ROLES.client ? 8 : 12}>
        <CustomTextField inputName={'name'} value={user.name} handleInputChange={handleInputChange} />
      </Grid>

      {[ROLES.client].includes(user.role_id) && authUser.role_id !== 6 && (
        <Grid xs={12} sm={4}>
          <UserBrandAutocomplete user={user} userSelected={userSelected} handleInputChange={handleInputChange} />
        </Grid>
      )}
    </Grid>
  )
}
